define(function (require) {
    "use strict";

    var LE = require("app"),
        ApiResources = require("assets/data/apiResources.json"),
        BaseCollection = require("collections/BaseCollection"),
        TicketModel = require("connection-models/ticketTab/TicketModel"),
        LEResourceResolver = require("leResourceResolver"),
        TicketCollection;
    var OrganizeCollectionDecorator = require("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");
    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        TicketCollection = BaseCollection.extend({
            resource: ApiResources.ConnectionPanel.Tickets,
            model: TicketModel,
            hasNoTickets: true,
            parse: function (resp, options) {
                if (resp && resp.tickets) {
                    if (resp.tickets.length > 0) {
                        this.hasNoTickets = false;
                    }
                    return resp.tickets;
                } else if (resp) {
                    if (resp.length > 0) {
                        this.hasNoTickets = false;
                    }
                    return resp;
                } else {
                    this.reset();
                }
            },
            initialize: function (models,options) {
                options = options || {};
                if(options.hasNoTickets === false){
                    this.hasNoTickets = false;
                }
                this.resource.url = LEResourceResolver.getUrl(this.resource.url);
                this.closedTickets = null;
                this.openTickets = null;
                this.closedTicketsWithBugs = null;
            },

            filterTickets:function(filterInfoModel){
                this.organize(filterInfoModel);
                if(this.closedTickets&&_.isFunction(this.closedTickets.organize)){
                    this.closedTickets.organize(filterInfoModel);
                }
                if(this.openTickets&&_.isFunction(this.openTickets.organize)){
                    this.openTickets.organize(filterInfoModel);
                }
                if (this.closedTicketsWithBugs&&_.isFunction(this.closedTicketsWithBugs.organize)) {
                    this.closedTicketsWithBugs.organize(this._filterInfo);
                }
            },

            filterBySummary: function (searchTerm) {
                var term = searchTerm.replace(/\s\s*$/, "");
                if (term.length > 0) {
                    var predicate = this._getFilteringPredicate(term.toLocaleLowerCase());
                    this._filterInfo = {
                        filterModel: {
                            predicate: predicate,
                            filteredWith: term
                        }
                    };
                }
                else {
                    if (this._filterInfo && this._filterInfo.filterModel) {
                        this._filterInfo.filterModel = null;
                    }
                }
                if (_.isFunction(this.organize)) {
                    this.organize(this._filterInfo);
                    if (this.closedTickets&&_.isFunction(this.closedTickets.organize)) {
                        this.closedTickets.organize(this._filterInfo);
                    }
                    if (this.openTickets&&_.isFunction(this.openTickets.organize)) {
                        this.openTickets.organize(this._filterInfo);
                    }
                    if (this.closedTicketsWithBugs&&_.isFunction(this.closedTicketsWithBugs.organize)) {
                        this.closedTicketsWithBugs.organize(this._filterInfo);
                    }
                }
            },

            _getFilteringPredicate: function (term) {
                return function (model) {

                    var searchTerms = term.split(" ");
                    var searchResults = [];

                    _.each(searchTerms,function(oneTerm){
                        var found = false;
                        _.some(model.attributes,function(value){
                            if(value && value.toString().toLocaleLowerCase().indexOf(oneTerm) > -1 && !_.isBoolean(value)){
                                found = true;
                                return found;//return true on first hit -> speedup a search a little bit
                            }
                        });
                        searchResults.push(found);
                    });
                    return (searchResults.indexOf(false)===-1); //if no false -> all search terms have been found -> match
                };
            },

            filterByClose: function(){
                this._setClosedTicket();
                this._setOpenTickets();
                this._setClosedWithBugTickets();
            },

            _setClosedTicket: function () {
                var closedTicketsModels = _.filter(this.getOriginalCollection().models, function(model){
                    return model.isClosed();
                });
                this.closedTickets = new OrganizeCollectionDecorator(new TicketCollection(closedTicketsModels,{
                    hasNoTickets: closedTicketsModels.length <= 0
                }));
            },

            _setClosedWithBugTickets: function() {
                var closedTicketsWithBugsModels = _.filter(this.getOriginalCollection().models,function(model){
                    return model.isClosedWithPendingBug();
                });
                this.closedTicketsWithBugs =  new OrganizeCollectionDecorator(new TicketCollection(closedTicketsWithBugsModels,{
                    hasNoTickets: closedTicketsWithBugsModels.length <= 0
                }));
            },

            _setOpenTickets: function () {
                var openTicketsCollections = _.filter(this.getOriginalCollection().models,function(model){
                    return !model.isClosed() && !model.isClosedWithPendingBug();
                });
                this.openTickets = new OrganizeCollectionDecorator(new TicketCollection(openTicketsCollections, {
                    hasNoTickets: openTicketsCollections.length <= 0
                }));
            },

            getClosedTicket: function(){
                return this.openTickets;
            },

            getClosedTicketsWithBugs: function(){
                return this.closedTicketsWithBugs;
            },

            getOpenTicket: function(){
                return this.closedTickets;
            }
        });
    });

    return TicketCollection;
});
